// extracted by mini-css-extract-plugin
module.exports = {"pdfViewerFrame":"pdfviewer_pdfViewerFrame__2o0ag"};